import { css } from '@emotion/react';
import { bpoints } from '../../../Utils';

export function residualValuesCSS() {
    return css` 
        width: 100%;

        .flexConteiner {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 2rem !important;
        }

       @media (max-width: ${bpoints.mobile.w}px) {
         .container-input {
            width: 90% !important;
            padding: 0rem !important;
        }
      }

        .container-input {
            width: 240px ;
            text-align: center;
            padding: 1rem;
        }

        .TextInput {
            width: 100%;
        }

        .SectionTable {
            width: 100% !important;
            display: flex !important;
            justify-content: space-evenly !important;
            gap: 1em !important;
            a{
                color: #206a80;
            }
            .tableAutos {
                width: 50% !important;
            }
        }

        @media (max-width: ${bpoints.mobile.w}px) {
            .SectionTable {
                display: block !important;

                .tableAutos {
                    width: 100% !important;
                    margin-bottom: 10px !important;
                }
            }
        }

        .Tooltip{
            display: flex;
            gap: 1rem;
            justify-content: start;
            margin-top: .3rem;
            padding-left: .4rem;
            .TooltipIndividual{
                display: flex;
                gap: .5rem;
                align-items: center;
                font-size: .8rem;
                justify-content: start;
            }
        }
        .p-radiobutton{
            display: flex;
            justify-content: center;
            align-items: center;
            gap: .5rem;
        }
            

    `;
}
